import styles from "../../styles/base/Register.module.scss";
import error_astonished from "../../assets/base/error_astonished.png";
import { Button } from "@qastanfit/qastan-ui"
import { useNavigate } from "react-router-dom";
import { getContent } from "../../functions/general/translations";
import { useAppSelector } from "../../hooks/redux";
import { useTranslation } from "react-i18next";

export default function ErrorForm({...props}){
    const { error, onBack } = props;
    const {t} = useTranslation()
    const navigate = useNavigate()

    const codeToMessage = (code:number) => {
        switch (code) {
            case 100:
                return t("ErrorForm.error_100")
            case 101:
                return t("ErrorForm.error_101")
            case 102:
                return t("ErrorForm.error_102")
            case 103:
                return t("ErrorForm.error_103")
            case 104:
                return t("ErrorForm.error_104")
            case 105:
                return t("ErrorForm.error_105")
            case 106:
                return t("ErrorForm.error_106")
            case 107:   
                return t("ErrorForm.error_107")
            case 108:   
                return t("ErrorForm.error_108")
            case 109:   
                return t("ErrorForm.error_109")
            case 110:   
                return t("ErrorForm.error_110")
            case 111:   
                return t("ErrorForm.error_111")
            case 112:   
                return t("ErrorForm.error_112")
            case 113:   
                return t("ErrorForm.error_113")
            case 114:   
                return t("ErrorForm.error_114")
            case 200:   
                return t("ErrorForm.error_200")
            case 201:   
                return t("ErrorForm.error_201")
            case 202:   
                return t("ErrorForm.error_202")
            case 204:   
                return t("ErrorForm.error_204")
            case 206:   
                return t("ErrorForm.error_206")
            case 207:   
                return t("ErrorForm.error_207")
            default:
                console.log(code);
                return t("ErrorForm.error_other")
        }
    }

    return (
        <div className={styles.registerform}>
            <div className={styles.registerform_wrapper}>
                <div className={styles.content}>
                    <img className={styles.emoji} src={error_astonished} alt="waving hand"/>
                    <h1 className='text-2xl font-bold'>{t("ErrorForm.title")}</h1>
                    <p className={styles.description}>{codeToMessage(error.errorcode)}</p>
                    <Button onClick={()=>{onBack(); navigate("/")}} styling={{marginTop:"2rem"}}>{t("ErrorForm.button_back")}</Button>
                </div> 
            </div>
        </div>
    )
}